import React from "react";
import {BackButtonComponent} from "../BackButton/BackButtonComponent";
import {scrollbarCss} from "../../../theme/theme";
import {HStack, VStack} from "@chakra-ui/react";

export const BaseContentPage = ({children}: { children: React.ReactNode }) => {
    return <VStack w={"100%"} overflow={"hidden"}>
        <BackButtonComponent/>
        <HStack w={"100%"} h={"100%"} spacing={0} overflow={"auto"} css={scrollbarCss}>
            {children}
        </HStack>
    </VStack>
}
